module.exports = __webpack_public_path__ + "static/media/c.c2eddb67.png";